import React from 'react';
import { ArrowUp, Mail, Linkedin, Download } from 'lucide-react';
import Button from './ui/Button';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const contactInfo = {
    email: 'wimboro@gmail.com',
    phone: '+62 822 3402 7884',
    location: 'Jakarta, Indonesia',
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="section-rule border-t border-white/10 bg-btc-void">
      <div className="container-max section-padding py-24">
        <div className="grid gap-6 md:grid-cols-12">
          <div className="surface-card p-8 md:col-span-5 md:p-10">
            <p className="label">10. Index</p>
            <p className="mt-4 font-heading text-4xl font-bold leading-tight md:text-5xl">
              Wimboro Galasakti P.
            </p>
            <p className="label mt-4">HSE Professional</p>
            <p className="mt-6 leading-relaxed text-btc-muted">
              Last role was HSE Officer at PT Pertamina Drilling Services Indonesia,
              on the PDSI #09.2/N80UE onshore rig, through September 2026.
              Available for the next HSE role.
            </p>
          </div>

          <div className="surface-card p-8 md:col-span-4 md:p-10">
            <p className="label">Contact</p>
            <dl className="mt-6 space-y-4">
              <div>
                <dt className="label">Location</dt>
                <dd className="mt-1 font-mono text-sm text-white">{contactInfo.location}</dd>
              </div>
              <div>
                <dt className="label">Email</dt>
                <dd className="mt-1">
                  <a
                    href={`mailto:${contactInfo.email}`}
                    className="font-mono text-sm text-btc-orange hover:underline"
                  >
                    {contactInfo.email}
                  </a>
                </dd>
              </div>
              <div>
                <dt className="label">Phone</dt>
                <dd className="mt-1 font-mono text-sm text-white">{contactInfo.phone}</dd>
              </div>
            </dl>
          </div>

          <div className="surface-card flex flex-col justify-between p-8 md:col-span-3 md:p-10">
            <div>
              <p className="label">Actions</p>
              <div className="mt-6 flex flex-col gap-3">
                <Button href="/documents/CV-Wimboro.pdf" download className="w-full">
                  <Download size={14} strokeWidth={2} />
                  CV
                </Button>
                <Button href={`mailto:${contactInfo.email}`} variant="secondary" className="w-full">
                  <Mail size={14} strokeWidth={2} />
                  Email
                </Button>
                <a
                  href="https://www.linkedin.com/in/wimboro/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-btc-outline w-full"
                >
                  <Linkedin size={14} strokeWidth={2} />
                  LinkedIn
                </a>
              </div>
            </div>
            <div className="mt-8 flex flex-wrap gap-2">
              {['HSE', 'Drilling', 'Marine', 'K3 Migas'].map((skill) => (
                <span
                  key={skill}
                  className="rounded-full border border-white/15 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-btc-muted"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <p className="font-mono text-xs uppercase tracking-widest text-btc-muted">
            © {currentYear} Wimboro Galasakti P.
          </p>
          <button
            type="button"
            onClick={scrollToTop}
            className="inline-flex min-h-11 items-center gap-2 font-mono text-xs font-medium uppercase tracking-widest text-btc-orange"
          >
            Top
            <ArrowUp size={14} strokeWidth={2} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
